module.exports = __webpack_public_path__ + "img/杂志期刊.c2aca991.svg";